import { render, staticRenderFns } from "./PurchaseDuoStadagenPerBu.vue?vue&type=template&id=497abf08&"
import script from "./PurchaseDuoStadagenPerBu.vue?vue&type=script&lang=js&"
export * from "./PurchaseDuoStadagenPerBu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports